import Subscription from '@/page/subscription';
import './app.css';

function App() {
  return <Subscription />;
}

export default App;
